var map = {
	"./en.js": 239,
	"./hu.js": 240,
	"./index.js": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 238;


//////////////////
// WEBPACK FOOTER
// ./src/i18 ^\.\/.*\.js$
// module id = 238
// module chunks = 0